import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import backgroundImage from '../../../assets/images/home/maharashtra_background.png';
import { fetchWelcomeText } from '../../../services/Sections/Home/homeBannerService';
import formatLanguage from '../../../utils/formatLanguage';
import { useSelector } from 'react-redux';

function HeroBanner() {
  const [title, setTitle] = useState('Default Welcome Message');
  const [description, setDescription] = useState('Default description');
  const [error, setError] = useState(null);

  const { selectedLanguage } = useSelector((state) => state.language);
  useEffect(() => {
    const getWelcomeText = async () => {
      try {
        const language = formatLanguage(selectedLanguage);

        const data = await fetchWelcomeText(language);

        setTitle(data.welcomeMessage || 'Default Welcome Message');
        setDescription(data.description || 'Default description');
      } catch (err) {
        console.error('Failed to fetch welcome text:', err);
        setError('Failed to load content.');
      }
    };

    getWelcomeText();
  }, [selectedLanguage]);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: { xs: '300px', sm: '400px', md: '500px', lg: '500px' },
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        color: 'white',
        px: { xs: 2, sm: 4, md: 6 },
      }}
    >
      {/* Background Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))',
        }}
      />

      {/* Inner Content */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          maxWidth: '750px',
          textAlign: 'left',
        }}
      >
        {error ? (
          <Typography
            variant="body1"
            sx={{
              color: 'red',
              fontSize: { xs: '1rem', sm: '1.2rem' },
            }}
          >
            {error}
          </Typography>
        ) : (
          <>
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2rem', lg: '2.3rem' },
                fontWeight: 'bold',
                color: 'white',
                mb: { xs: 1.2, sm: 1.5 },
                lineHeight: { xs: 1.2, sm: 1.4, md: 1.5 },
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: 'white',
                fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem', lg: '1.2rem' },
                lineHeight: { xs: 1.4, sm: 1.6, md: 1.7 },
                maxWidth: { xs: '100%', sm: '90%', md: '80%' },
              }}
            >
              {description}
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
}

export default HeroBanner;